import { useState } from 'react';
import PropTypes from 'prop-types';
import { StyledModalComponent, changeColorShade } from '@dnhb/node_package';
import styled from '@emotion/styled';
import InfoSvg from 'images/shared/info.svg';

const Heading = styled.h1`
  color: ${({ theme }) => theme.primaryColor};
  font-weight: 600;
  font-size: 30px;
  margin-bottom: 22px;
  line-height: 38px;
  max-width: calc(100% - 48px);

  @media ${({ theme }) => theme.mobile} {
    word-break: break-word;
  }
`;

const Icontainer = styled.button`
  margin-left: 8px;
  vertical-align: middle;
  line-height: 16px;
  cursor: pointer;
  border-radius: 50%;

  &:focus svg, &:hover svg  {
    fill: ${({theme}) => changeColorShade(theme.primaryColor)};
  }
    
  svg {
    display: block;
    width: 16px;
    height: 16px;
    fill: ${({theme}) => theme.primaryColor};
  }
`;

export default function Info(props) {
  const { children, title } = props;
  const [isOpen, closeModal] = useState(false);

  const toggleModal = () => {
    closeModal(!isOpen);
  };


  return (
    <>
      <Icontainer type="button" onClick={e => {
        e.preventDefault()
        toggleModal()
      }}>
        <InfoSvg />
      </Icontainer>
      <StyledModalComponent isOpen={isOpen} onRequestClose={toggleModal} maxWidth={540}>
        <Heading>{title}</Heading>
        <div>{children}</div>
      </StyledModalComponent>
    </>
  );
}

Info.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
};

Info.defaultProps = {
  title: '',
};
